// Usando HTTP requests diretas com CORS habilitado
import { auth, functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

const FUNCTIONS_URL = process.env.REACT_APP_FUNCTIONS_URL || 'https://us-central1-sdc-turismo.cloudfunctions.net';

const getAuthHeaders = async () => {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const user = auth.currentUser;
    if (user) {
      const idToken = await user.getIdToken();
      headers['Authorization'] = 'Bearer ' + idToken;
    }
  } catch (err) {
    // Não foi possível obter idToken
  }
  return headers;
};

/**
 * Envia email de boas-vindas para nova empresa
 */
export const sendWelcomeEmail = async (companyData) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`${FUNCTIONS_URL}/sendWelcomeEmail`, {
      method: 'POST',
      headers,
      body: JSON.stringify(companyData)
    });

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.error || 'Erro ao enviar email');
    }

    return { success: true, data: result };
  } catch (error) {
    console.error('Erro ao enviar email:', error);
    return { success: false, error: error.message };
  }
};

export const sendCompanyNoticeEmail = async (noticeData) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`${FUNCTIONS_URL}/sendCompanyNoticeEmail`, {
      method: 'POST',
      headers,
      body: JSON.stringify(noticeData)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || 'Erro ao enviar aviso por email');
    return { success: true, data: result };
  } catch (error) {
    console.error('Erro ao enviar aviso por email:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Reenvia email de credenciais
 */
export const resendCredentials = async (companyId) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`${FUNCTIONS_URL}/resendCompanyCredentials`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ companyId })
    });

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.error || 'Erro ao reenviar email');
    }

    return { success: true, data: result };
  } catch (error) {
    console.error('Erro ao reenviar email:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Envia email de boas-vindas para novo colaborador
 */
export const sendCollaboratorWelcomeEmail = async (collaboratorData) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`${FUNCTIONS_URL}/sendCollaboratorWelcomeEmail`, {
      method: 'POST',
      headers,
      body: JSON.stringify(collaboratorData)
    });

    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.error || 'Erro ao enviar email do colaborador');
    }

    return { success: true, data: result };
  } catch (error) {
    console.error('Erro ao enviar email do colaborador:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Cria um colaborador via Cloud Function (sem deslogar o admin)
 */
export const createCollaborator = async (collaboratorData) => {
  const createError = (err) => {
    const code = String(err?.code || '').toLowerCase();
    const message = String(err?.message || '').toLowerCase();

    if (
      ['permission-denied', 'already-exists', 'invalid-argument', 'unauthenticated', 'conflict', 'email-already-exists'].includes(code) ||
      message.includes('já cadastrado') ||
      message.includes('already exists') ||
      message.includes('email já cadastrado')
    ) {
      return { success: false, error: err.message || 'Erro ao criar colaborador' };
    }

    return null;
  };

  try {
    const createCallable = httpsCallable(functions, 'createCollaboratorCallable');
    const res = await createCallable(collaboratorData);
    return { success: true, data: res.data };
  } catch (err) {
    const knownError = createError(err);
    if (knownError) {
      return knownError;
    }
  }

  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`${FUNCTIONS_URL}/createCollaborator`, {
      method: 'POST',
      headers,
      body: JSON.stringify(collaboratorData)
    });

    const result = await response.json().catch(() => ({}));

    if (response.ok) {
      return { success: true, data: result };
    }

    const fallbackError = createError({
      code: response.status === 409 ? 'already-exists' : undefined,
      message: result?.error || `Erro na requisição (${response.status})`
    });

    return fallbackError || { success: false, error: result.error || 'Erro na requisição' };
  } catch (err) {
    const knownError = createError(err);
    if (knownError) {
      return knownError;
    }
    console.error('createCollaborator fetch failed:', err);
    return { success: false, error: err.message || String(err) };
  }
};
